module.exports = __webpack_public_path__ + "img/case1.8ea0ac13.png";